import { render, staticRenderFns } from "./modal-termos-atendimento.vue?vue&type=template&id=53f0a423&scoped=true&"
import script from "./modal-termos-atendimento.vue?vue&type=script&lang=js&"
export * from "./modal-termos-atendimento.vue?vue&type=script&lang=js&"
import style0 from "./modal-termos-atendimento.vue?vue&type=style&index=0&id=53f0a423&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f0a423",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCheckbox,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f0a423')) {
      api.createRecord('53f0a423', component.options)
    } else {
      api.reload('53f0a423', component.options)
    }
    module.hot.accept("./modal-termos-atendimento.vue?vue&type=template&id=53f0a423&scoped=true&", function () {
      api.rerender('53f0a423', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/modal/atendimento/modal-termos-atendimento/modal-termos-atendimento.vue"
export default component.exports